import siteOptions from '@/config/index'

/**
 * 过滤菜单，通过本地权限配置.
 * @return Promise.
 */
export function filterMenu(menuConfig){
	if(siteOptions['permScheme']['type'] == 1) {
		// 过滤菜单，通过异步 全局变量.
		return new Promise(makePromiseHandler(menuConfig, 0));
	} else {
		// 过滤菜单，通过异步 api.
		return new Promise(makePromiseHandler(menuConfig, 1));
	}
}

function makePromiseHandler(menuConfig, permType){
	return function(resolve, reject) {
		let handler = permCodes=>{
			try {
				resolve(filterMenuByLocalPerm(menuConfig, permCodes || []));
			} catch(e) {
				console.log(e)
				reject('菜单过滤失败!')
			}
		}
		if(permType) {
			siteOptions['permScheme']['getCodes']().then(handler)
		} else {
			// 权限码可能是服务器端渲染到html，公布到全局变量中的。
			handler(siteOptions['permScheme']['getCodes']())
		}
	}
}

function filterMenuByLocalPerm(menuConfig, permCodes){
	let filterMenus = (menus)=>{
		return menus.filter(item=>{
			let isPermed = !item['code'] || (item['code'] && permCodes.includes(item['code']))
			if(isPermed && item['children'] && item['children'].length){
				item['children'] = filterMenus(item['children'])
				if(!item['children'].length){
					delete item['children']
				}
			}
			return isPermed
		})
	}
	return filterMenus(menuConfig)
}
